import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { inject } from '@angular/core';
import { EncryptionStorageService } from './services/encryption-storage.service';

export const driverGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authGuardService: AuthService = inject(AuthService);
  const encryptStorage: EncryptionStorageService = inject(EncryptionStorageService);
  const roleName = encryptStorage.getItem('roleName')
  if (authGuardService.isLoggedIn() && roleName ==='Driver') {
    return true;

  } router.navigate(['login'])
    return false
};
